export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
              <i className="ri-mail-send-line"></i>
              互动交流
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">联系与投稿</h2>
            <p className="mt-2 text-foreground-500 text-sm">期待与每一位追剧爱好者的交流与合作</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            <div className="p-6 rounded-xl bg-background-100 border border-background-200 text-center">
              <div className="w-12 h-12 mx-auto rounded-xl bg-primary-100 flex items-center justify-center mb-3">
                <i className="ri-mail-line text-primary-600 text-xl"></i>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-500">business@8090cinema.com</p>
            </div>
            <div className="p-6 rounded-xl bg-background-100 border border-background-200 text-center">
              <div className="w-12 h-12 mx-auto rounded-xl bg-accent-100 flex items-center justify-center mb-3">
                <i className="ri-edit-2-line text-accent-600 text-xl"></i>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1">内容投稿</h3>
              <p className="text-xs text-foreground-500">contribute@8090cinema.com</p>
            </div>
            <div className="p-6 rounded-xl bg-background-100 border border-background-200 text-center">
              <div className="w-12 h-12 mx-auto rounded-xl bg-secondary-100 flex items-center justify-center mb-3">
                <i className="ri-customer-service-2-line text-secondary-600 text-xl"></i>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1">用户反馈</h3>
              <p className="text-xs text-foreground-500">feedback@8090cinema.com</p>
            </div>
          </div>

          <div className="mt-8 p-6 rounded-xl bg-background-100 border border-background-200 text-center">
            <p className="text-sm text-foreground-600 leading-relaxed">
              如果您是影视内容创作者，我们热忱欢迎您向8090影院投稿剧评、追剧指南和行业观察文章。
              同时也欢迎各大影视制作方与我们建立合作关系，共同为观众带来更多<strong className="text-foreground-900">高清免费追剧</strong>的精彩内容。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}